/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CreateDashboardEnvRequest,
  DashboardEnvRequest,
  GetV11DashboardsEnvParams,
  PostV11DashboardsEnvParams,
  UserEnvResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary dashboard env 조회
 */
export const getV11DashboardsEnv = (
  params?: MaybeRef<GetV11DashboardsEnvParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<UserEnvResponse>(
    { url: `/api/v11/dashboards/env`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11DashboardsEnvQueryKey = (params?: MaybeRef<GetV11DashboardsEnvParams>) => {
  return ['api', 'v11', 'dashboards', 'env', ...(params ? [params] : [])] as const;
};

export const getGetV11DashboardsEnvQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11DashboardsEnv>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11DashboardsEnvParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsEnv>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11DashboardsEnvQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11DashboardsEnv>>> = ({ signal }) =>
    getV11DashboardsEnv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11DashboardsEnv>>,
    TError,
    TData
  >;
};

export type GetV11DashboardsEnvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11DashboardsEnv>>
>;
export type GetV11DashboardsEnvQueryError = ErrorType<unknown>;

/**
 * @summary dashboard env 조회
 */

export function useGetV11DashboardsEnv<
  TData = Awaited<ReturnType<typeof getV11DashboardsEnv>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11DashboardsEnvParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsEnv>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11DashboardsEnvQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary dashboard env 등록
 */
export const postV11DashboardsEnv = (
  createDashboardEnvRequest: MaybeRef<CreateDashboardEnvRequest[]>,
  params?: MaybeRef<PostV11DashboardsEnvParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  createDashboardEnvRequest = unref(createDashboardEnvRequest);
  params = unref(params);

  return customAxiosInstance<string>(
    {
      url: `/api/v11/dashboards/env`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDashboardEnvRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV11DashboardsEnvMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV11DashboardsEnv>>,
    TError,
    { data: BodyType<CreateDashboardEnvRequest[]>; params?: PostV11DashboardsEnvParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV11DashboardsEnv>>,
  TError,
  { data: BodyType<CreateDashboardEnvRequest[]>; params?: PostV11DashboardsEnvParams },
  TContext
> => {
  const mutationKey = ['postV11DashboardsEnv'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV11DashboardsEnv>>,
    { data: BodyType<CreateDashboardEnvRequest[]>; params?: PostV11DashboardsEnvParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV11DashboardsEnv(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV11DashboardsEnvMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV11DashboardsEnv>>
>;
export type PostV11DashboardsEnvMutationBody = BodyType<CreateDashboardEnvRequest[]>;
export type PostV11DashboardsEnvMutationError = ErrorType<unknown>;

/**
 * @summary dashboard env 등록
 */
export const usePostV11DashboardsEnv = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV11DashboardsEnv>>,
      TError,
      { data: BodyType<CreateDashboardEnvRequest[]>; params?: PostV11DashboardsEnvParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV11DashboardsEnv>>,
  TError,
  { data: BodyType<CreateDashboardEnvRequest[]>; params?: PostV11DashboardsEnvParams },
  TContext
> => {
  const mutationOptions = getPostV11DashboardsEnvMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary dashboard env 삭제
 */
export const deleteV11DashboardsEnv = (
  dashboardEnvRequest: MaybeRef<DashboardEnvRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  dashboardEnvRequest = unref(dashboardEnvRequest);

  return customAxiosInstance<string>(
    {
      url: `/api/v11/dashboards/env`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardEnvRequest,
    },
    options,
  );
};

export const getDeleteV11DashboardsEnvMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV11DashboardsEnv>>,
    TError,
    { data: BodyType<DashboardEnvRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV11DashboardsEnv>>,
  TError,
  { data: BodyType<DashboardEnvRequest> },
  TContext
> => {
  const mutationKey = ['deleteV11DashboardsEnv'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV11DashboardsEnv>>,
    { data: BodyType<DashboardEnvRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteV11DashboardsEnv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV11DashboardsEnvMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV11DashboardsEnv>>
>;
export type DeleteV11DashboardsEnvMutationBody = BodyType<DashboardEnvRequest>;
export type DeleteV11DashboardsEnvMutationError = ErrorType<unknown>;

/**
 * @summary dashboard env 삭제
 */
export const useDeleteV11DashboardsEnv = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV11DashboardsEnv>>,
      TError,
      { data: BodyType<DashboardEnvRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV11DashboardsEnv>>,
  TError,
  { data: BodyType<DashboardEnvRequest> },
  TContext
> => {
  const mutationOptions = getDeleteV11DashboardsEnvMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
